

const calenderIcon = () => {
  return (
    <div>
        <svg width="72" height="84" viewBox="0 0 72 84" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="72" height="84" rx="4" fill="#F2F4F7"/>
<g clip-path="url(#clip0_2129_8497)">
<path d="M18 57V29H54V57C54 58.1 53.1 59 52 59H20C18.9 59 18 58.1 18 57Z" fill="#9EB5D9"/>
<rect x="22.625" y="37.006" width="26.75" height="2.54324" rx="1.27162" fill="#E7EDF6"/>
<rect x="22.625" y="42.7281" width="23.9198" height="2.54324" rx="1.27162" fill="#E7EDF6"/>
<rect x="22.625" y="48.4507" width="15.5311" height="2.54324" rx="1.27162" fill="#E7EDF6"/>
<path d="M54 25V31H18V25C18 23.9 18.9 23 20 23H52C53.1 23 54 23.9 54 25Z" fill="#0D47A1"/>
<path opacity="0.05" d="M47.5 29.5C45.843 29.5 44.5 28.157 44.5 26.5V23H50.5V26.5C50.5 28.157 49.157 29.5 47.5 29.5Z" fill="#4D4845" fill-opacity="0.9"/>
<path opacity="0.07" d="M47.5 28.75C46.257 28.75 45.25 27.743 45.25 26.5V23H49.75V26.5C49.75 27.743 48.743 28.75 47.5 28.75Z" fill="#4D4845" fill-opacity="0.9"/>
<path opacity="0.05" d="M24.5 29.5C22.843 29.5 21.5 28.157 21.5 26.5V23H27.5V26.5C27.5 28.157 26.157 29.5 24.5 29.5Z" fill="#4D4845" fill-opacity="0.9"/>
<path opacity="0.07" d="M24.5 28.75C23.257 28.75 22.25 27.743 22.25 26.5V23H26.75V26.5C26.75 27.743 25.743 28.75 24.5 28.75Z" fill="#4D4845" fill-opacity="0.9"/>
<path d="M24.5 28C23.672 28 23 27.328 23 26.5V22.5C23 21.672 23.672 21 24.5 21C25.328 21 26 21.672 26 22.5V26.5C26 27.328 25.328 28 24.5 28Z" fill="#3D6CB4"/>
<path d="M47.5 28C46.672 28 46 27.328 46 26.5V22.5C46 21.672 46.672 21 47.5 21C48.328 21 49 21.672 49 22.5V26.5C49 27.328 48.328 28 47.5 28Z" fill="#3D6CB4"/>
</g>
<defs>
<clipPath id="clip0_2129_8497">
<rect width="48" height="48" fill="white" transform="translate(12 17)"/>
</clipPath>
</defs>
</svg>

    </div>
  )
}

export default calenderIcon